import React, { Component, Fragment } from 'react';
import { Card, Button } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { CKEditor } from '@ckeditor/ckeditor5-react';
//import BalloonEditor from '@ckeditor/ckeditor5-build-balloon';
import moment from 'moment';
import MioScanographyPDF from './MioScanographyPDF';
import { TextField } from '@material-ui/core';
import Spinner from 'react-bootstrap/Spinner';


class ReportForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id_informe: '',
            motivo_consulta: this.props.history.motivo_consulta != null && this.props.history.motivo_consulta != undefined ? this.props.history.motivo_consulta : null,
            antecedentes: "",
            observacionesDos: "",
            observaciones: this.props.history.observaciones != null && this.props.history.observaciones != undefined ? this.props.history.observaciones : null,
            lengua: "",
            conclusiones: this.props.history.conclusion != null && this.props.history.conclusion != undefined ? this.props.history.conclusion : null,
            recomendaciones: this.props.history.recomendaciones != null && this.props.history.recomendaciones != undefined ? this.props.history.recomendaciones : null,
            age: '',
            mioescanografia: {
                dinamometria: '',
                labios: '',
                lengua: '',
                maseteros_der: '',
                maseteros_izq: ''
            },
            disableInput: false,
            exist: false,
            onUpdate: false,
            loading: true,

        }
    }

    handlerMioescanografia = (field, value) => {
        this.setState({ mioescanografia: { ...this.state.mioescanografia, [field]: value } })
    }

    componentDidMount() {
        this.getDataHistory();
    }

    getDataHistory = () => {
        if (this.props.dataHistory.length > 0) {
            const data = this.props.dataHistory;
            for (let i = 0; i < data.length; i++) {
                if (data[i].tipo_informe === 5) {
                    this.setState({
                        loading: false,
                        id_informe: data[i].id_hist_informes,
                        motivo_consulta: data[i].motivo_consulta,
                        antecedentes: data[i].antecedentes_paciente,
                        lengua: data[i].lengua_payne,
                        observaciones: data[i].observacion,
                        observacionesDos: data[i].observacion2,
                        conclusiones: data[i].conclusion,
                        recomendaciones: data[i].recomendaciones,
                        mioescanografia: data[i].mioescanografia.mioescanografia,
                        exist: true,
                        disableInput: true
                    });
                } else if ((i + 1) === data.length) {
                    this.setState({ loading: false });
                }
            }
        } else {
            this.setState({ loading: false });
        }
    }


    makePdf = async () => {
        console.log(this.props);
        const dataPdf = {
            names: this.props.data.nombres,
            documentNumber: this.props.data.num_documento,
            edad: this.state.age,
            motivo_consulta: this.state.motivo_consulta,
            observaciones: this.state.observaciones,
            observacionesDos: this.state.observacionesDos,
            antecedentes: this.state.antecedentes,
            lengua: this.state.lengua,
            conclusiones: this.state.conclusiones,
            recomendaciones: this.state.recomendaciones,
            mioescanografia: this.state.mioescanografia,
            age: this.props.age,//this.state.age,
            plan: this.props.planName, //this.state.planName,
            id_historia: this.props.data.id_historia,
            documentNumber: this.props.data.num_documento,
            telephone: this.props.data.telephone !== null ? this.props.data.telephone : '',
            address: this.props.data.adress.direccion !== null ? this.props.data.adress.direccion: '',
            ocupation: this.props.data.ocupacion !== null ? this.props.data.ocupacion :'',
            remitente: this.props.data.remitente,
            fecha: this.props.data.fecha,
            hora: this.props.data.fecha_ingreso_completa,
        }
        MioScanographyPDF(dataPdf);
    }

    saveData = async () => {
        //Descripcion- Interpretacion
        const dataToSend = {
            id_historia: this.props.data.id_historia,
            id_admision: this.props.data.id_admision,
            motivo_consulta: this.state.motivo_consulta,
            procedimiento: this.state.procedimiento,
            parametro_estimulacion: '',
            resultados: '',           
            interpretacion: '',
            observacion: this.state.observaciones === '' ? this.props.history.observaciones : this.state.observaciones,
            recomendaciones: this.state.recomendaciones,
            conclusion: "",
            nota: "",
            fecha: this.props.data.fecha, //moment(new Date(this.props.data.fecha)).format("YYYY-MM-DD"),
            id_servicio: null,
            tipo_informe: 5,
            antecedentes_paciente: this.state.antecedentes,
            lengua_payne: this.state.lengua,
            observacion2: this.state.observacionesDos,
            mioescanografia: this.state.mioescanografia,
        }

        await fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-informe/create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataToSend)
        })
            .then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.text();
                }
            })
            .then(data => {
                console.log(data);
                this.makePdf().then(() => {
                    this.setState({ disableInput: true, exist: true });
                });
            })
            .catch((error) => {
                console.error('Error:', error);

            });
    }

    updateData = () => {

        //Descripcion - Interpretacion
        const dataToSend = {
            id_hist_informes: this.state.id_informe,
            id_historia: this.props.data.id_historia,
            id_admision: this.props.data.id_admision,
            motivo_consulta: this.state.motivo_consulta,
            procedimiento: this.state.procedimiento,
            parametro_estimulacion: '',
            resultados: '',            
            interpretacion: '',
            observacion: this.state.observaciones === '' ? this.props.history.observaciones : this.state.observaciones,
            recomendaciones: this.state.recomendaciones,
            conclusion: "",
            nota: "",
            fecha: this.props.data.fecha, //moment(new Date(this.props.data.fecha)).format("YYYY-MM-DD"),
            id_servicio: null,
            tipo_informe: 5,
            antecedentes_paciente: this.state.antecedentes,
            lengua_payne: this.state.lengua,
            observacion2: this.state.observacionesDos,
            mioescanografia: this.state.mioescanografia,

        }

        fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-informe/update', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(dataToSend)
        })
            .then(response => {
                if (response.status != 500 && response.status != 403) {
                    return response.text();
                }
            })
            .then(data => {
                console.log(data);
                this.makePdf().then(() => {
                    //window.location.reload();
                    this.setState({ disableInput: true, exist: true, onUpdate: false });
                });

            })
            .catch((error) => {
                console.error('Error:', error);
                //reject(error)
            });
    }

    render() {

        return (
            <Card>
                {this.state.loading ?
                    <div className="text-center">
                        <Spinner animation="border" variant="success" />
                    </div>
                    :
                    <Fragment>
                        <div className="form" style={{ flex: 1, flexDirection: 'column', display: 'flex' }}>
                            <div className="card__title">
                                <h5 className="bold-text">Resumen De Historia Clinica </h5>
                            </div>

                            <div style={{ flexDirection: 'row', display: 'flex', marginTop: 20 }}>

                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Antecedentes/ Motivo de Consulta</span>
                                    <div className="form__form-group-field">
                                        <textarea
                                            name="textarea-motivo-consulta"
                                            value={this.state.motivo_consulta}
                                            onChange={(e) => { this.setState({ motivo_consulta: e.target.value }) }}
                                            disabled={this.state.disableInput}
                                        >
                                        </textarea>
                                    </div>
                                </div>

                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Antecedentes Personales y Familiares </span>
                                    <div className="form__form-group-field">
                                        <textarea
                                            name="textarea-procedimiento"
                                            value={this.state.antecedentes}
                                            onChange={(e) => { this.setState({ antecedentes: e.target.value }) }}
                                            disabled={this.state.disableInput}
                                        >
                                        </textarea>
                                    </div>
                                </div>
                            </div>

                            <div style={{ flexDirection: 'row', display: 'flex', marginTop: 20 }}>

                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Observacion General </span>
                                    <div className="form__form-group-field">

                                        <textarea
                                            name="textarea-interpretacion"
                                            value={this.state.observaciones}
                                            onChange={(e) => { this.setState({ observaciones: e.target.value }) }}
                                            disabled={this.state.disableInput}
                                        >
                                        </textarea>
                                    </div>
                                </div>

                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Lengua en Reposo</span>
                                    <div className="form__form-group-field">

                                        <textarea
                                            name="textarea-observacion"
                                            value={this.state.lengua}
                                            onChange={(e) => { this.setState({ lengua: e.target.value }) }}
                                            disabled={this.state.disableInput}>
                                        </textarea>
                                    </div>
                                </div>

                            </div>

                            <div style={{ flexDirection: 'row', display: 'flex', marginTop: 20 }}>
                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Observaciones (Alimentacion)</span>
                                    <div className="form__form-group-field">

                                        <textarea
                                            name="textarea-observacion"
                                            value={this.state.observacionesDos}
                                            onChange={(e) => { this.setState({ observacionesDos: e.target.value }) }}
                                            disabled={this.state.disableInput}>
                                        </textarea>
                                    </div>
                                </div>

                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Conclusiones </span>
                                    <div className="form__form-group-field">

                                        <textarea
                                            name="textarea-observacion"
                                            value={this.state.conclusiones}
                                            onChange={(e) => { this.setState({ conclusiones: e.target.value }) }}
                                            disabled={this.state.disableInput}>
                                        </textarea>
                                    </div>
                                </div>

                            </div>

                            <div style={{ flexDirection: 'row', display: 'flex', marginTop: 20 }}>
                                <div className="form__form-group" style={{ margin: 10 }}>
                                    <span className="form__form-group-label">Recomendaciones </span>
                                    <div className="form__form-group-field">

                                        <textarea
                                            name="textarea-observacion"
                                            value={this.state.recomendaciones}
                                            onChange={(e) => { this.setState({ recomendaciones: e.target.value }) }}
                                            disabled={this.state.disableInput}>
                                        </textarea>
                                    </div>
                                </div>

                            </div>

                            <span style={{ marginTop: 15, marginLeft: 10 }} className="form__form-group-label">MioEscanografia </span>

                            <table className="table table--bordered" style={{ margin: 10, }}>
                                <thead>
                                    <tr>
                                        <th colSpan={2}>Labios </th >
                                        <th colSpan={2}>Lengua </th >
                                        <th colSpan={2}>Maseteros</th >
                                        <th colSpan={2}>Dinamometria </th >
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Normal </td>
                                        <td>Paciente </td>
                                        <td>Normal </td>
                                        <td>Paciente </td>
                                        <td>Normal </td>
                                        <td>Paciente </td>
                                        <td>Normal </td>
                                        <td>Paciente </td>
                                    </tr>
                                    <tr>
                                        <td>0,5 </td>
                                        <td> <TextField
                                            id="peso-standard"
                                            placeholder='0,7'
                                            type="number"
                                            className="medical-material-form__field"
                                            InputLabelProps={{
                                                style: { color: '#646777' }, shrink: true
                                            }}
                                            style={{ width: 70, }}
                                            value={this.state.mioescanografia.labios}
                                            onChange={(event) => {
                                                this.handlerMioescanografia('labios', event.target.value);
                                            }}
                                            disabled={this.state.disableInput}
                                        /> </td>
                                        <td>0,8 </td>
                                        <td> <TextField
                                            id="peso-standard"
                                            placeholder='0,7'
                                            type="number"
                                            className="medical-material-form__field"
                                            InputLabelProps={{
                                                style: { color: '#646777' }, shrink: true
                                            }}
                                            style={{ width: 70, }}
                                            value={this.state.mioescanografia.lengua}
                                            onChange={(event) => {
                                                this.handlerMioescanografia('lengua', event.target.value);
                                            }}
                                            disabled={this.state.disableInput}
                                        /> </td>
                                        <td>0,4 </td>
                                        <td> Der <TextField
                                            id="peso-standard"
                                            placeholder='0,7'
                                            type="number"
                                            className="medical-material-form__field"
                                            InputLabelProps={{
                                                style: { color: '#646777' }, shrink: true
                                            }}
                                            style={{ width: 70, }}
                                            value={this.state.mioescanografia.maseteros_der}
                                            onChange={(event) => {
                                                this.handlerMioescanografia('maseteros_der', event.target.value);
                                            }}
                                            disabled={this.state.disableInput}
                                        /> </td>
                                        <td>5 - 6 lbs </td>
                                        <td> <TextField
                                            id="peso-standard"
                                            placeholder='6'
                                            type="number"
                                            className="medical-material-form__field"
                                            InputLabelProps={{
                                                style: { color: '#646777' }, shrink: true
                                            }}
                                            style={{ width: 70, }}
                                            value={this.state.mioescanografia.dinamometria}
                                            onChange={(event) => {
                                                this.handlerMioescanografia('dinamometria', event.target.value);
                                            }}
                                            disabled={this.state.disableInput}
                                        /> </td>
                                    </tr>
                                    <tr>
                                        <td>0,8 </td>
                                        <td> </td>
                                        <td>1,2 </td>
                                        <td> </td>
                                        <td>0,7 </td>
                                        <td> Izq  <TextField
                                            id="peso-standard"
                                            placeholder='0,7'
                                            type="number"
                                            className="medical-material-form__field"
                                            InputLabelProps={{
                                                style: { color: '#646777' }, shrink: true
                                            }}
                                            style={{ width: 70, }}
                                            value={this.state.mioescanografia.maseteros_izq}
                                            onChange={(event) => {
                                                this.handlerMioescanografia('maseteros_izq', event.target.value);
                                            }}
                                            disabled={this.state.disableInput}
                                        /></td>
                                        <td> </td>
                                        <td> </td>
                                    </tr>
                                </tbody>

                            </table>

                            <div>
                                <Button
                                    style={{ marginRight: 12, marginTop: 20 }}
                                    size="sm"
                                    color="primary"
                                    onClick={() => {

                                        if (this.state.exist)
                                            this.makePdf();
                                        else
                                            this.saveData();
                                        ///this.generteReportPdf();

                                    }}
                                >
                                    {this.state.exist ? " Generar Reporte" : " Guardar y Generar Reporte"}

                                </Button>

                                {this.state.exist ?
                                    <Button
                                        style={{ marginTop: 20 }}
                                        size="sm"
                                        color="primary"
                                        onClick={() => {

                                            if (this.state.onUpdate)
                                                this.updateData();
                                            else
                                                this.setState({ disableInput: false, onUpdate: true });
                                        }}
                                    >
                                        {this.state.onUpdate ? "Actualizar" : " Habilitar Actualizacion"}
                                    </Button>
                                    : null}
                            </div>
                        </div>
                    </Fragment>}
            </Card>
        );
    }
}

export default reduxForm({
    form: 'report_ardila_form', // a unique identifier for this form
})(withTranslation('common')(ReportForm));